/* Import Module */
import { reactive } from "vue";
import { rentalContractEditForm } from "../variables";
import $ from "jquery";
import toastr from "toastr";

/* Define Const */
export const errors = reactive({
  slipNo: {
    hasError: false,
    message: "",
  },
  managerId: {
    hasError: false,
    message: "",
  },
  dispatchDate: {
    hasError: false,
    message: "",
  },
  rentCarNo: {
    hasError: false,
    message: "",
  },
  rentCarId: {
    hasError: false,
    message: "",
  },
  dischargeAmount: {
    hasError: false,
    message: "",
  },
  nocSubscriptionAmount: {
    hasError: false,
    message: "",
  },
  contractorCompanyName: {
    hasError: false,
    message: "",
  },
  contractorAddress: {
    hasError: false,
    message: "",
  },
  contractorManager: {
    hasError: false,
    message: "",
  },
  contractorTel: {
    hasError: false,
    message: "",
  },
  driverName: {
    hasError: false,
    message: "",
  },
  driverSex: {
    hasError: false,
    message: "",
  },
  driverBirthday: {
    hasError: false,
    message: "",
  },
  driverAddress: {
    hasError: false,
    message: "",
  },
  driverTel: {
    hasError: false,
    message: "",
  },
  driverLicenseNo: {
    hasError: false,
    message: "",
  },
  drivingLicenseTypeId: {
    hasError: false,
    message: "",
  },
  driverLicenseExpireYear: {
    hasError: false,
    message: "",
  },
  lentDate: {
    hasError: false,
    message: "",
  },
  lentTime: {
    hasError: false,
    message: "",
  },
  lentDateDrivingDistance: {
    hasError: false,
    message: "",
  },
  returnDate: {
    hasError: false,
    message: "",
  },
  returnTime: {
    hasError: false,
    message: "",
  },
  returnDateDrivingDistance: {
    hasError: false,
    message: "",
  },
  vehicleInspectionExpiryDate: {
    hasError: false,
    message: "",
  },
  maintenanceDate: {
    hasError: false,
    message: "",
  },
  maintenancePersonId: {
    hasError: false,
    message: "",
  },
  usageObjectiveId: {
    hasError: false,
    message: "",
  },
  destAddress: {
    hasError: false,
    message: "",
  },
  destManager: {
    hasError: false,
    message: "",
  },
  destTel: {
    hasError: false,
    message: "",
  },
  fuel: {
    hasError: false,
    message: "",
  },
  checkManagerId: {
    hasError: false,
    message: "",
  },
  processedDate: {
    hasError: false,
    message: "",
  },
  isAgreement: {
    hasError: false,
    message: "",
  },
  signaturePath: {
    hasError: false,
    message: "",
  },
  all: {
    hasError: false,
  },
});

/* 種別 一旦回収で仮置き */
const collectionTypeId = 2;

/* Define Script */
export const RentalContractValidate = async (response: any) => {
  // errors変数 初期化
  initializeErrors();

  Object.keys(response).forEach((key) => {
    // keyはrentalContract.slipNo などの形であるため加工する
    let exceptParentKey = key;
    if(key.includes('rentalContract.')) {
      exceptParentKey = key.replace('rentalContract.', '');
    }
    if(key.includes('carCheckSheets.')) {
      exceptParentKey = key.replace('carCheckSheets.', '');
    }
    let elm = $(`#${exceptParentKey}`);
    elm.addClass("is-invalid");

    errors[exceptParentKey].hasError = true;
    errors[exceptParentKey].message = response[key][0];
    errors.all.hasError = true;
  })

  if (errors.all.hasError) {
    /* Check Validation */
    // await RentalContractValidate("registration");
    // 入力エラーがある場合、処理を終了する
    $(".modal-body").animate({ scrollTop: 0 }, 600);
    toastr.error("入力の内容にエラーがあります");
  }
};

// 変数初期化処理
export const initializeErrors = () => {
  // errors変数 初期化
  Object.keys(errors).forEach((error) => {
    errors[error].hasError = false;
    if (error != "all") {
      errors[error].message = "";
    }
  });

  // is-invalid変数 削除
  Object.keys(rentalContractEditForm).forEach((input) => {
    let element = $(`#${input}`);
    if (element?.hasClass("is-invalid")) {
      element.removeClass("is-invalid");
    }
  });

  // canvas部品 初期化
  $("#VueDrawingCanvas").removeClass("border border-danger");
};
